const Status = {
  UNDEFINED: "undefined",
  SHIPPED: "shipped",
  REGISTERED: "registered",
  OFFLINE: "offline",
};

export default Status;
